enum TipoCotaEnum {
  ComCota = 1,
  SemCota = 2,
  NaoControlaCota = 3,
}

export default TipoCotaEnum
